/* eslint-disable eqeqeq */
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Redirect, Route, withRouter } from "react-router-dom";
// Toast:
import { ToastContainer } from "react-toastify";
// Maintenance:
import Maintenance from "../../Maintenance/Maintenance";
import { fetchBegin } from "../../reducers/Header";
import * as ServerService from "../../services/server/api_server";
import * as UsersService from "../../services/users/api_user";
//Stock Control
//Client
import ClientsDashboards from "../../Stations/ClientsDashboards";
import ChangePassword from "../../User/ChangePasswordPage";
// Login & Logout:
import Login from "../../User/LoginPage";
import Logout from "../../User/Logout";
// Protected Route:
import ProtectedRoute from "../../User/ProtectedRoute";
import Register from "../../User/Register";




class AppMain extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {},
      underMaintenance: false,
      resetPassword: false,
      resetPasswordToken: "",
    };
  }

  /*********************************** LIFECYCLE ***********************************/
  async componentDidMount() {
    this._isMounted = true;

    const _this = this;

    const domain = "bd.picadvanced.com";
    if (window.location.href.includes(domain)) {
      window.location = "https://76364.s.time4vps.cloud";
    }

    let token = "";
    if (window.location.href.includes("/resetPassword")) {
      let hrefParts = window.location.href.split("/");
      token = hrefParts[hrefParts.length - 1];
      _this.setState({ resetPassword: true, resetPasswordToken: token });
    }

    // Check if server is under maintenance:
    //console.log("### Check if it's under maintenance!");
    _this.setState({ underMaintenance: false });
    ServerService.isUnderMaintenance(function(result) {
      if (
        result !== undefined &&
        result != null &&
        result.data !== undefined &&
        result.data != null
      ) {
        const data = result.data;
        if (
          data.underMaintenance !== undefined &&
          data.underMaintenance == true
        ) {
          if (_this._isMounted) {
            _this.setState({ underMaintenance: true });
          }
          window.location = "/#/maintenance";
        }
      }
    });

    //Switch to function with more control
    const user = await UsersService.getCurrentUserInitial();

    if (_this._isMounted && user != null) {
      fetchBegin(this.props.location.pathname);
      _this.setState({ user });
    }

    if (
      !window.location.href.includes("/resetPassword") &&
      (user === undefined || user == null || user.id === undefined)
    ) {
      window.location = "/#/login";
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  /*********************************** RENDER ***********************************/
  render() {
    if (this._isMounted) {
      const { underMaintenance, resetPassword } = this.state;

      const grantAccess = UsersService.getAccessControl();

      return (
        <Fragment>
          {/* Login */}
          <Route
            path="/login"
            render={(props) => {
              if (underMaintenance) return <Redirect to="/maintenance" />;
              if (resetPassword)
                return (
                  <Redirect
                    to={{
                      pathname: "/resetPassword/:token",
                    }}
                  />
                );
              return <Login {...props} />;
            }}
          />
          <Route path="/register" component={Register} />
          {/* Logout */}
          <Route path="/logout" component={Logout} />

          {/* ChangePassword */}
          <Route
            path="/resetPassword/:token"
            render={(props) => {
              return <ChangePassword {...props} />;
            }}
          />

          {/* Maintenance */}
          <Route path="/maintenance" component={Maintenance} />

          {/************************* PROTECTED ROUTES - LOGIN *************************/}

          {/* Clients */}
          <ProtectedRoute
            path="/pica_cs_vz"
            render={(props) => {
              if (underMaintenance) return <Redirect to="/maintenance" />;
              else if (grantAccess == 1)
                return <ClientsDashboards {...props} />;
              else return <Redirect to="/" />;
            }}
          />

          {/* DEFAULT MAIN */}
          <ProtectedRoute
            exact
            path="/"
            render={() => {
              if (underMaintenance) return <Redirect to="/maintenance" />;
              else if (grantAccess == 1) return <Redirect to="/pica_cs_vz" />;
              else if (grantAccess == 2) return <Redirect to="/pica_cs_vz" />;
              else if (grantAccess == 3) return <Redirect to="/pica_cs_vz" />;
              else return <Redirect to="/maintenance" />;
            }}
          />

          <ToastContainer />
        </Fragment>
      );
    } else {
      return null;
    }
  }
}
const mapStateToProps = (state) => ({
  sidebarXFP: state.Header.sidebarXFP,
});
const mapDispatchToProps = (dispatch) => ({
  fetchBegin: (url) => dispatch(fetchBegin(url)),
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(AppMain)
);



// WEBPACK FOOTER //
// ./src/Layout/AppMain/index.js